// Sentry MUST initialize before any other import so it can instrument
// React, react-router, and axios. No-op when REACT_APP_SENTRY_DSN is empty.
import { initSentry, SentryErrorBoundary } from "@/sentry";
initSentry();

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SentryErrorBoundary
      fallback={
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#05050A",
            color: "#94a3b8",
            fontFamily: "system-ui, sans-serif",
            padding: "2rem",
            textAlign: "center",
          }}
        >
          <div style={{ maxWidth: "28rem" }}>
            <h1 style={{ color: "#f8fafc", fontSize: "1.5rem", marginBottom: "0.75rem" }}>
              Something went wrong
            </h1>
            <p style={{ lineHeight: 1.6, marginBottom: "1.5rem" }}>
              Government Shield ran into an unexpected error. We've been
              notified. You can try reloading; if the problem persists,
              it's safe to log in from a fresh browser tab.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: "#3b82f6",
                color: "#fff",
                border: "none",
                padding: "0.6rem 1.25rem",
                borderRadius: "0.5rem",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Reload
            </button>
          </div>
        </div>
      }
    >
      <App />
    </SentryErrorBoundary>
  </React.StrictMode>,
);
